import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

// components
import { AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { PreviewBox, Image, Title, Button, Description } from './StyledElements';

const ButtonStyled = styled(Button)`
  width: 24%;
  position: absolute;
  right: 10%;
  bottom: 33px;
`;

interface OwnProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate1: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <PreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <Image isTemplateSelected={isTemplateSelected} />
      <Title />
      <ButtonStyled isTemplateSelected={isTemplateSelected} />
      <Description />
      <Description />
      <Description />
    </PreviewBox>
  );
};

export default PreviewTemplate1;
